import * as React from "react";
const SvgFiRrSeatAirline = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-seat-airline_svg__a)">
      <path
        fill="#062147"
        d="M21 22H9a.99.99 0 0 1-.851-.474.99.99 0 0 1-.044-.974l1.005-2.009a7 7 0 0 0 2.48.456h7.409c.88 0 1.714-.385 2.286-1.057a3.01 3.01 0 0 0 .674-2.44C21.727 14.075 20.408 13 18.893 13h-7.29c-.45 0-.845-.303-.963-.736L10.022 10H19a1 1 0 1 0 0-2H9.475l-1.55-5.668C7.52.784 6.076-.214 4.565.008a3 3 0 0 0-2.067 1.313A3 3 0 0 0 2.1 3.742l2.733 10.09a7 7 0 0 0 2.526 3.74l-1.043 2.086a2.98 2.98 0 0 0 .132 2.92A2.98 2.98 0 0 0 9 24h12A1 1 0 1 0 21 22M4.033 3.227a.98.98 0 0 1 .133-.803.98.98 0 0 1 .812-.446c.45 0 .88.357 1.016.872l2.716 9.941a3.006 3.006 0 0 0 2.894 2.21h7.289c.537 0 1.017.361 1.093.823A1 1 0 0 1 19 17h-7.41a5.01 5.01 0 0 1-4.825-3.692z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-seat-airline_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSeatAirline;
